import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { useGetStatisticsRevenueSubmission } from '@nxsys/hooks/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useEffect, useMemo, useState } from 'react';
import ExpenseModal from './components/ExpenseModal';
import PSRModal, { PSRModalTypeEnum } from './components/PSRModal';

type Props = {
  /** NX-6253: dark tiles matching the UK umbrella RTI Filling cards. */
  dark?: boolean;
};

const RevenueSubmission = ({ dark = false }: Props) => {
  const { value, loading, run } = useGetStatisticsRevenueSubmission();
  const data = useMemo(() => value?.data, [value]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState<PSRModalTypeEnum | null>(null);
  const [isOpenExpenseModal, setIsOpenExpenseModal] = useState(false);

  useEffect(() => {
    run();
  }, []);

  const handleOpenModal = (type: PSRModalTypeEnum) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  const items = [
    {
      title: data?.totalSubmitPSR,
      description: 'Submit PSR',
      icon: <Icons.IconFileText />,
      iconBgColor: 'bg-cyan-100',
      onClick: () => handleOpenModal(PSRModalTypeEnum.SUBMIT_PSR),
    },
    // NX-6140: both still open a modal, but on PSR Submissions rather than the
    // per-employee screens - a run is one row now, with its payslips inside.
    {
      title: data?.totalSubmittedPSRError,
      description: 'PSR Error Submissions',
      icon: <Icons.IconFileText />,
      iconBgColor: 'bg-error-300',
      onClick: () => handleOpenModal(PSRModalTypeEnum.PSR_ERROR_SUBMISSIONS),
    },
    {
      title: data?.totalSubmittedPSR,
      description: 'PSR History',
      icon: <Icons.IconFileText />,
      iconBgColor: 'bg-cyan-100',
      onClick: () => handleOpenModal(PSRModalTypeEnum.PSR_HISTORY),
    },
  ];

  return (
    <div className="RevenueSubmission">
      <AppCard className="p-[24px]" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconFileText" title="Revenue Submissions" />
        </div>
        <div className="grid grid-cols-3 gap-[16px] max-sm:grid-cols-1">
          {items.map((item) => (
            <div
              key={item.title}
              className={`border ${dark ? 'border-[#00CA98] bg-[#072627] text-white' : 'border-[#CDDDD9]'} dashboard-hover-card rounded-[8px] p-[16px]`}
              onClick={item.onClick}
            >
              <div className="flex items-center justify-between gap-x-[8px] mb-[34px]">
                <div
                  className={`${item.iconBgColor} ${dark ? 'text-[#072627]' : ''} rounded-[8px] p-[8px]`}
                >
                  {item.icon}
                </div>
                <Icons.IconArrowRight />
              </div>
              <div className="text-[22px] font-bold mb-[8px]">{item.title}</div>
              <div className="text-[14px] font-bold">{item.description}</div>
            </div>
          ))}
        </div>
      </AppCard>
      {modalType && (
        <PSRModal
          isOpen={isOpenModal}
          toggle={() => setIsOpenModal(false)}
          type={modalType}
          cbAfterAction={run}
        />
      )}
      <ExpenseModal
        isOpen={isOpenExpenseModal}
        toggle={() => setIsOpenExpenseModal(false)}
        cbAfterAction={run}
      />
    </div>
  );
};

export default RevenueSubmission;
